import { z } from 'zod';

const nonNegativeNumber = z.number().nonnegative();

const countSchema = z.object({
    count: nonNegativeNumber,
    countOnly: z.boolean().optional(),
    offset: nonNegativeNumber.optional(),
    pages: z.number().nonnegative(),
});

export const paginationSchema = countSchema.extend({
    page: nonNegativeNumber.nullable().transform((value) => value ?? 1),
    size: nonNegativeNumber.nullable().transform((value) => value ?? 1),
});

export type Pagination = z.infer<typeof paginationSchema>;

export const simplePaginationSchema = z.object({
    count: z.number().int().nonnegative(),
    page: z.number().int().nonnegative(),
    pages: z.number().int().nonnegative(),
    size: z.number().int().positive(),
});

export type SimplePagination = z.infer<typeof simplePaginationSchema>;

export const paginationCountResponseSchema = z.object({
    pagination: countSchema,
});

export type PaginatedResponse<T> = {
    readonly data: readonly T[];
    readonly pagination: Pagination;
};

export type PaginationCountResponse = z.infer<typeof paginationCountResponseSchema>;

export const relatedSkillsResponseSchema = z.object({
    relatedSkillData: paginationCountResponseSchema,
});

export type RelatedSkillsResponse = z.infer<typeof relatedSkillsResponseSchema>;
